import {
  DATE_CALCULATIONS,
  DATE_FORMAT_OPTIONS,
  DATE_FORMATTING,
  DATE_LOCALE,
} from '../constants/general';

export const formatNotificationTime = (createdAt: Date): string => {
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - new Date(createdAt).getTime());
  const diffDays = Math.ceil(diffTime / DATE_CALCULATIONS.MILLISECONDS_IN_DAY);

  if (diffDays <= DATE_CALCULATIONS.MAX_DAYS_FOR_RELATIVE_FORMAT) {
    if (diffDays === DATE_CALCULATIONS.ONE_DAY) {
      return DATE_FORMATTING.ONE_DAY_AGO;
    }
    return `${diffDays} ${DATE_FORMATTING.DAYS_AGO}`;
  }

  const date = new Date(createdAt);
  return date.toLocaleDateString(DATE_LOCALE, DATE_FORMAT_OPTIONS.FULL_DATE);
};

export const formatMonthYear = (date: Date): string => date.toLocaleDateString(
  DATE_LOCALE,
  DATE_FORMAT_OPTIONS.MONTH_YEAR,
);
